var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},[_c('section',{staticClass:"padding_30 padbot_45"},[_c('app-title',{attrs:{"label":"Portfolio (Hobby Projects)"}}),_c('a-row',{attrs:{"gutter":32}},_vm._l((_vm.displayProjects),function(project,index){return _c('appPortfolioCard',{key:index,attrs:{"cardData":project}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }